import { render } from "./Proiecte.vue?vue&type=template&id=2708047c"
import script from "./Proiecte.vue?vue&type=script&lang=js"
export * from "./Proiecte.vue?vue&type=script&lang=js"

import "./Proiecte.vue?vue&type=style&index=0&id=2708047c&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__